/**
 * recycleBin.service.ts — Layer 3: Recycle Bin / Deleted Items Domain
 */

import { getRequest, postRequest, deleteRequest } from './http.service';
import {
  URL_DELETED_ITEMS,
  URL_DELETED_FOLDERS,
  URL_DELETED_ITEM_RESTORE,
  URL_DELETED_ITEM_PERMANENT,
  URL_DELETED_FOLDER_RESTORE,
  URL_DELETED_FOLDER_PERMANENT,
} from './url.service';

/** Get a page of deleted (soft-deleted) items matching a caller-built query string */
export const fetchDeletedItems = (qs: string) =>
  getRequest(`${URL_DELETED_ITEMS}?${qs}`);

/** Restore a soft-deleted item */
export const restoreDeletedItem = (itemId: string) =>
  postRequest(URL_DELETED_ITEM_RESTORE(itemId), {});

/** Permanently delete an item */
export const permanentlyDeleteItem = (itemId: string) =>
  deleteRequest(URL_DELETED_ITEM_PERMANENT(itemId));

/** Get a page of deleted folders matching a caller-built query string */
export const fetchDeletedFolders = (qs: string) =>
  getRequest(`${URL_DELETED_FOLDERS}?${qs}`);

/** Restore a soft-deleted folder */
export const restoreDeletedFolder = (folderId: string) =>
  postRequest(URL_DELETED_FOLDER_RESTORE(folderId), {});

/** Permanently delete a folder */
export const permanentlyDeleteFolder = (folderId: string) =>
  deleteRequest(URL_DELETED_FOLDER_PERMANENT(folderId));
